module.exports = __webpack_public_path__ + "img/IMG_9447.4cd6900b.jpg";